export default function PopularCategoriesSection() {
  const handleClick = (index: number) => {
    const urls = [
      "https://kaspreadsheet.com/category-911-Shoes.html",
      "https://kaspreadsheet.com/search-912/name/Shoes.html",
      "https://kaspreadsheet.com/search-914/name/Shoes.html",
      "https://kaspreadsheet.com/search-920/name/Shoes.html",
      "https://kaspreadsheet.com/search-921/name/Shoes.html",
      "https://kaspreadsheet.com/search-923/name/Shoes.html",
    ];
    window.open(urls[index] || "https://kaspreadsheet.com", "_blank", "noopener,nofollow");
  };

  const popularCategories = [
    {
      name: "Sneakers Spreadsheet",
      description: "Najlepsze sneakersy i najnowsze trendy w jednym arkuszu",
      icon: "ri-footprint-line",
      imageUrl: "https://readdy.ai/api/search-image?query=Arranged%20pair%20of%20white%20minimalist%20sneakers%20with%20natural%20linen%20fabric%20draped%20alongside%20on%20warm%20sand%20colored%20surface%2C%20soft%20directional%20side%20lighting%2C%20editorial%20still%20life%2C%20terracotta%20pottery%20fragment%20in%20background%2C%20clean%20serene%20composition&width=600&height=380&seq=pop-cat-sneakers-v2&orientation=landscape",
    },
    {
      name: "Streetwear Spreadsheet",
      description: "Kompletny arkusz streetwear z najlepszymi okazjami",
      icon: "ri-t-shirt-line",
      imageUrl: "https://readdy.ai/api/search-image?query=Folded%20oversized%20cotton%20hoodie%20in%20muted%20olive%20tone%20with%20minimalist%20cap%20resting%20on%20top%2C%20textured%20cream%20backdrop%2C%20soft%20overcast%20studio%20light%2C%20editorial%20fashion%20flat%20lay%2C%20subtle%20fabric%20wrinkles%20and%20organic%20textile%20details&width=600&height=380&seq=pop-cat-streetwear-v2&orientation=landscape",
    },
    {
      name: "Luxury Fashion Spreadsheet",
      description: "Ekskluzywne marki i luksusowe produkty w zasięgu ręki",
      icon: "ri-vip-diamond-line",
      imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20leather%20wallet%20and%20silk%20scarf%20draped%20gracefully%20on%20smooth%20marble%20surface%2C%20golden%20hour%20warm%20lighting%20from%20side%2C%20luxury%20editorial%20product%20photography%2C%20soft%20caramel%20and%20blush%20pink%20color%20accents%2C%20refined%20sophisticated%20minimalism&width=600&height=380&seq=pop-cat-luxury-v2&orientation=landscape",
    },
    {
      name: "Electronics Spreadsheet",
      description: "Najlepsze gadżety i elektronika z Chin – sprawdzone linki",
      icon: "ri-smartphone-line",
      imageUrl: "https://readdy.ai/api/search-image?query=Wireless%20earbuds%20and%20sleek%20smartwatch%20positioned%20on%20minimalist%20concrete%20surface%20with%20small%20potted%20succulent%2C%20clean%20daylight%20from%20above%2C%20tech%20editorial%20style%2C%20warm%20beige%20and%20graphite%20gray%20palette%2C%20contemporary%20workspace%20vibe&width=600&height=380&seq=pop-cat-electronics-v2&orientation=landscape",
    },
    {
      name: "Accessories Spreadsheet",
      description: "Akcesoria modowe i dodatki w jednym miejscu",
      icon: "ri-glasses-line",
      imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20sunglasses%20and%20minimalist%20belt%20laid%20on%20organic%20cotton%20fabric%20with%20gentle%20folds%2C%20soft%20diffused%20daylight%2C%20editorial%20accessory%20photography%2C%20warm%20earth%20tones%20of%20clay%20and%20sand%2C%20effortless%20casual%20elegance&width=600&height=380&seq=pop-cat-accessories-v2&orientation=landscape",
    },
    {
      name: "Jewelry & Watches Spreadsheet",
      description: "Biżuteria i zegarki z najlepszych chińskich marketplace",
      icon: "ri-vip-crown-line",
      imageUrl: "https://readdy.ai/api/search-image?query=Delicate%20gold%20toned%20necklace%20and%20minimalist%20wristwatch%20displayed%20on%20natural%20stone%20tile%20surface%2C%20soft%20candlelight%20warmth%2C%20editorial%20jewelry%20photography%2C%20ivory%20cream%20and%20soft%20bronze%20color%20harmony%2C%20intimate%20romantic%20aesthetic&width=600&height=380&seq=pop-cat-jewelry-v2&orientation=landscape",
    },
  ];

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-900 tracking-tight leading-tight">
          Popularne Arkusze
        </h2>
        <h2 className="font-heading text-3xl md:text-5xl font-extralight italic text-foreground-600 tracking-tight leading-tight mt-1">
          Spreadsheet
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {popularCategories.map((cat, idx) => (
            <button
              key={cat.name}
              onClick={() => handleClick(idx)}
              className="bg-background-50 border border-background-200/80 rounded-xl overflow-hidden hover:border-primary-300/60 transition-all duration-300 text-left group cursor-pointer"
            >
              <div className="h-48 bg-background-100 flex items-center justify-center overflow-hidden relative">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-6 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className={`${cat.icon} text-primary-600 text-xs`}></i>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-foreground-600 text-xs leading-relaxed">
                  {cat.description}
                </p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}